import React, {useContext,useState} from "react";
import axios from "axios";
import {Elink, RequestMoveDate} from '../CommonComponents/Routes'
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";

// used to  set/change the the service date .
export default () => {
    let Record = useContext(RecordsManagementContext)
    let RecordsController = Record.CP_PageDetails.EstimateAndCompanyInfo.Estimate
    let PageView = useContext(ViewMangementContext)
    const [date, setDate] = useState(new Date());

    const saveMoveDate = () => { // the request is send to the "request_to_move_date" function in "client_portal_controller" in Moveitpro(ruby on rails project) to update the service date .
        Record.setRequestMoveDateShown(false) //it is set to false to hide the "request move date" btn.
            PageView.CloseModal() // use to close or hide the modal
        const formattedDate = format(date, Record.CP_PageDetails.date_format);
            axios({
                method: 'post',
                url: RequestMoveDate,
                contentType: "application/json",
                data: {
                    estimate_key: Elink,
                    service_date: formattedDate
                }
            }).then((response) => { // fetch the data and update the page view
                PageView.setModalContent({Title: '', Body: '', Class: ''})
                let Message = response.data.Message
                if(Message && Message.Text === "Expired Link"){
                    window.location.reload();
                }
                else{
                    if (Message && Message.Status && Message.Status === "failed") {
                        PageView.setAlertProperty({
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                    } else {
                        Record.SetCP_PageDetails({
                            ...Record.CP_PageDetails,
                            ClientPortalHeader: { // hide the request move date button
                                ...Record.CP_PageDetails.ClientPortalHeader,
                                RequestMoveDate: !(response.data[0] === undefined || response.data[0] === false)
                            },
                            EstimateStatistics: { // update move date
                                ...Record.CP_PageDetails.EstimateStatistics,
                                MoveDate: response.data[1]
                            }
                        })
                        // set the alert box on the page.
                        PageView.setAlertProperty({
                            Message: "Move Date Successfully Updated .",
                            Type: 'success', Show: true, AutoHide: true
                        })
                    }
                }
            })
    }

    return(
        <>
            <div >
                <strong>Service Date : </strong>
            <br/>
                <DatePicker  onChangeRaw={(e) => e.preventDefault()}
                             selected={date} onChange={date => setDate(date)} dateFormat= {Record.CP_PageDetails.date_format}/>
                <br/> <br/>
                This does not confirm your booking. The booking is only confirmed after we
                contact you back letting you know that the date you selected is available.
            </div>
            <div className='footer-btn'>
                <button className="btn btn-primary" data-dismiss="modal"
                        onClick={() => saveMoveDate()}>Submit</button>
            </div>
        </>
    )
}